<template>
  <section id="gened-test-results-block" class="all-cases-view">
    <el-row :gutter="20" type="flex">
      <el-col :span="8">
        <div class="gened-test-card">
          <h4 class="title">FILTERS RESULTS</h4>

          <div class="border-bottom"></div>
          <div class="listings-navbar filters-results-inputs">
            <div class="form-element input-with-icon">
              <el-input
                v-model="search_string"
                @input="getAutoCompleteCasesData"
                @clear="clearOrdersSearch"
                placeholder="Search"
                :clearable="true"
              >
              </el-input>
              <span class="search-icon">
                <img
                  src="@/assets/images/icons/search-icon-with-bg-red.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
            </div>
            <div class="calender-filters">
              <div class="calender-filters-input">
                <el-date-picker
                  v-model="search_from_date"
                  type="date"
                  placeholder="From date"
                  format="MM-DD-YYYY"
                  value-format="YYYY-MM-DD"
                  :disabled-date="disabledDate"
                  @change="fetchAllCases(1)"
                >
                </el-date-picker>
              </div>
              <div class="calender-filters-input">
                <el-date-picker
                  v-model="search_to_date"
                  type="date"
                  placeholder="To date"
                  format="MM-DD-YYYY"
                  value-format="YYYY-MM-DD"
                  :disabled-date="disabledDate"
                  @change="fetchAllCases(1)"
                >
                </el-date-picker>
              </div>
            </div>
            <div class="calender-filters">
              <div
                class="calender-filters-input"
                v-if="getAuthenticatedUser.user_type !== 'HOSPITAL_PHYSICIAN'"
              >
                <el-select
                  placeholder="Select Ordering Facility"
                  @change="fetchAllCases(1)"
                  v-model="search_hospital"
                  :filterable="true"
                  :clearable="true"
                >
                  <el-option
                    v-for="(hospital, index) in hospitalsData.data"
                    :key="index"
                    :value="hospital._id"
                    :label="hospital.name"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="calender-filters-input"
                v-if="getAuthenticatedUser.user_type !== 'HOSPITAL_PHYSICIAN'"
              >
                <el-select
                  placeholder="Select Physician"
                  v-model="search_ordering_physician"
                  @change="fetchAllCases(1)"
                  :filterable="true"
                  :clearable="true"
                >
                  <el-option
                    v-for="(item, index) in physiciansData.data"
                    :key="index"
                    :value="item._id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </div>
              <div class="calender-filters-input">
                <el-select
                  placeholder="Select Status"
                  v-model="search_case_status"
                  @change="fetchAllCases(1)"
                  :filterable="true"
                  :clearable="true"
                  v-if="getAuthenticatedUser.user_type === 'HOSPITAL_PHYSICIAN'"
                >
                  <el-option
                    v-for="(status, index) in allCasePhysicianStatus"
                    :key="index"
                    :value="status.value"
                    :label="status.name"
                  ></el-option>
                </el-select>

                <el-select
                  placeholder="Select Status"
                  v-model="search_case_status"
                  @change="fetchAllCases(1)"
                  :filterable="true"
                  :clearable="true"
                  v-else
                >
                  <el-option
                    v-for="(status, index) in allCaseStatus"
                    :key="index"
                    :value="status.value"
                    :label="status.name"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="action-btn">
              <el-button
                class="add-btn"
                @click="clearAllFilters"
                :disabled="disableFilters"
                >CLEAR FILTERS
              </el-button>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="10">
        <!-- Web Version -->
        <div
          class="primary-content-view-new"
          v-if="getAllCases"
          v-loading="loading"
        >
          <div
            class="listings listings__table listings__all-cases"
            id="all-cases-listings"
          >
            <el-table
              height="calc(100vh - 295px)"
              :data="casesTable.data"
              @sort-change="onChangeSort"
              :row-class-name="currentSelectedRowClassName"
              @selection-change="handleSelectionChange($event)"
            >
              <el-table-column
                prop="accession_id"
                label="Accession #"
                min-width="150"
              >
                <template #default="scope">
                  <div class="name-accession">
                    <span id="accession-id">
                      {{ scope.row.accession_id }}
                    </span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                label="Patient Name"
                min-width="200"
                prop="patient_info.first_name"
              >
                <template #default="scope">
                  <span class="patient-name">
                    {{ convertToUppercase(getPatientNameByInfo(scope.row.patient_info)) }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column width="120">
                <template #default="scope">
                  <div class="table-buttons">
                    <el-button
                      class="button-added"
                      v-if="isSelectedAccession(scope.row.accession_id)"
                    >
                      ADDED
                    </el-button>

                    <el-button
                      class="button-add"
                      @click="addCases(scope.row)"
                      v-else
                      >ADD</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="listings listings__pagination">
            <el-pagination
              v-model:currentPage="page"
              v-model:page-size="pageSize"
              :page-sizes="[20, 25, 50, 100]"
              layout=" prev, pager, next, jumper, sizes ,total"
              :total="casesTable.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="selected-accession-id">
          <div class="primary-content-view-new">
            <div
              class="listings listings__table listings__all-cases"
              id="all-cases-listings"
            >
              <el-table :data="selectedData" height="calc(100vh - 270px)">
                <el-table-column
                  label="Accession ID"
                  prop="accession_id"
                ></el-table-column>
                <el-table-column label="Actions" width="120">
                  <template #default="scope">
                    <el-button
                      class="action-remove"
                      @click="handleRemoveAccession(scope.$index)"
                    >
                      REMOVE</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import caseDataHelper from "@/mixins/caseDataHelper";
import caseConstants from "@/config/constants/caseConstants";
import moment from "moment-timezone";
export default {
  props: ["positions", "selectedPosition", "caseType", "accessionData"],
  computed: {
    ...mapGetters("cases", ["getAllCases"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    paginationProps() {
      return {
        pageSizes: this.pageSizes || [10, 20, 50, 100],
      };
    },
    isFiltersApplied() {
      let filters = this.getSelectedFilters();
      return Object.keys(filters).length > 0;
    },
    disableFilters() {
      if (
        !this.search_string &&
        !this.search_from_date &&
        !this.search_to_date &&
        !this.search_hospital &&
        !this.search_ordering_physician &&
        !this.search_case_status.length
      ) {
        return true;
      }
      return false;
    },
    isSelectedAccession() {
      return (accession) =>
        this.selectedAccessionIds.indexOf(accession) != -1 ? true : false;
    },
  },
  async mounted() {
    this.selectedCaseIds = [];
    this.search_string = "";
    this.selectedData = JSON.parse(JSON.stringify(this.accessionData));
    Promise.all([
      this.fetchAllCases(this.page),
      this.fetchAllHospitals(),
      this.fetchAllPhysicians(),
    ]);
    this.getLabCaseTypes();
  },
  data() {
    return {
      selectedData: [],
      search_from_date: null,
      search_to_date: null,
      position: "",
      positionsData: [],
      search_string: "",
      search_case_type: [],
      search_ordering_physician: "",
      search_hospital: "",
      search_case_status: "",
      caseTypes: [],
      previousSearchString: "",
      page: 1,
      loading: false,
      casesTable: {},
      selectedCaseId: null,
      fieldList: [],
      from_date: "",
      to_date: "",
      hospital: "",
      hospital_branch: "",
      ordering_physician: "",
      case_types: [],
      case_status: "",
      caseIds: [],
      selectedCaseIds: [],
      pageSize: 20,
      orderBy: "",
      orderType: "",
      allCaseStatus: caseConstants.CASE_STATUS,
      allCasePhysicianStatus: caseConstants.CASE_PHYSICIAN_STATUS,

      selectedAccessionIds: [],
      newAccessions: [],
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      hospitalsData: {},
      physiciansData: {},
    };
  },

  mixins: [caseDataHelper],

  methods: {
    getLabCaseTypes() {
      this.caseTypes = this.getLabBasedCaseTypes(caseConstants.CASE_TYPES_DATA);
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "";
        this.orderType = "";
      }
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchAllCases(this.page);
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchAllCases(this.page);
    },
    // This Method is used for mobile pagination
    clearAllFilters() {
      let alreadyFilteredApplied = this.isFiltersApplied;

      this.search_string = "";
      this.search_case_type = "";
      this.search_case_status = "";
      this.search_ordering_physician = "";
      this.search_hospital = "";
      this.search_from_date = "";
      this.search_to_date = "";

      if (alreadyFilteredApplied) {
        this.fetchAllCases(1);
      }
    },

    getSelectedFilters() {
      let filters = {};
      if (this.orderBy && this.orderType) {
        filters.order_by = this.orderBy;
        filters.order_type = this.orderType;
      }

      if (this.caseType) {
        filters.case_type = this.caseType;
      }
      if (this.search_ordering_physician) {
        filters.ordering_physician = this.search_ordering_physician;
      }

      if (this.search_hospital) {
        filters.hospital = this.search_hospital;
      }

      if (this.search_case_status) {
        filters.status = [this.search_case_status];
      }

      if (this.search_string) {
        filters.search_string = this.search_string;
      }

      if (this.search_from_date) {
        filters.from_date = moment
          .tz(this.getProfileData.lab.timezone)
          .set(this.getLabTimeZoneData(this.search_from_date))
          .startOf("day")
          .utc()
          .format();
      }

      if (this.search_to_date) {
        filters.to_date = moment
          .tz(this.getProfileData.lab.timezone)
          .set(this.getLabTimeZoneData(this.search_to_date))
          .endOf("day")
          .utc()
          .format();
      }

      return filters;
    },

    async fetchAllCases(page) {
      this.page = page;

      this.loading = true;

      let params = { page: page, limit: this.pageSize };

      let filters = this.getSelectedFilters();

      params = { ...params, ...filters };

      let statusDetails = null;
      if (params.status) {
        statusDetails = params.status[0];
        params.status = [];
        statusDetails.split(",").forEach((e) => params.status.push(e));
      }
      await this.$store.dispatch("cases/setCaseInformationToNull", params);
      await this.$store.dispatch("cases/fetchAllCases", params);
      this.casesTable = JSON.parse(JSON.stringify(this.getAllCases));

      if (statusDetails) {
        params.status = statusDetails;
      }

      this.loading = false;
    },
    async getAutoCompleteCasesData() {
      // to eleminate empty search strings
      if (this.search_string.trim() === this.previousSearchString) {
        return;
      }

      this.previousSearchString = this.search_string.trim();

      this.page = 1;
      this.loading = true;
      let params = { page: this.page };
      let filters = this.getSelectedFilters();
      params = { ...params, ...filters };

      await this.$store.dispatch("cases/setCaseInformationToNull", params);
      await this.$store.dispatch("cases/fetchAllCases", params);

      if (
        !this.search_string ||
        this.getAllCases.search_string === this.search_string.trim()
      ) {
        this.casesTable = JSON.parse(JSON.stringify(this.getAllCases));
        this.loading = false;
      } else if (this.getAllCaseErrors) {
        this.loading = false;
      }
    },
    clearOrdersSearch() {
      this.search_string = "";
      this.previousSearchString = "";
      this.fetchAllCases(1);
    },

    async fetchAllHospitals() {
      await this.$store.dispatch("hospitals/fetchAllHospitals", {
        get_all: true,
      });
      this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
    },
    async fetchAllPhysicians() {
      this.hospital_branch = null;
      this.ordering_physician = null;
      let params = {};
      let params1 = {};
      if (this.hospital != "") {
        params.hospital = this.hospital;
        params1.hospital_id = this.hospital;
      } else {
        params.get_all = true;
        params1.get_all = true;
      }
      await this.$store.dispatch("physicians/fetchAllPhysicians", params);
      this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
      if (params1.hospital_id) {
        await this.$store.dispatch("branches/fetchAllBranches", params1);
      }
    },

    currentSelectedRowClassName({ row }) {
      if (this.selectedAccessionIds.indexOf(row.accession_id) != -1) {
        return "selected";
      } else {
        return "not-selected";
      }
    },
    handleRemoveAccession(index) {
      this.selectedData.splice(index, 1);
      this.$emit("saveAccessionData", this.selectedData);
    },
    addCases(data) {
      if (this.selectedAccessionIds.indexOf(data.accession_id) == -1) {
        this.selectedData.push({
          accession_id: data.accession_id,
          case_id: data._id,
          report_status: "TO-START",
        });
      }
      this.$emit("saveAccessionData", this.selectedData);
    },
    handleSelectionChange(val) {
      if (val) {
        this.newAccessions = val.map((el) => el.accession_id);
        this.addCases();
      } else {
      }
    },
  },
  watch: {
    selectedData: {
      immediate: true,
      deep: true,
      handler: function () {
        this.selectedAccessionIds = this.selectedData.map(
          (el) => el.accession_id
        );
      },
    },

    accessionData() {
      this.selectedData = this.accessionData;
    },
    caseType() {
      this.fetchAllCases(1);
    },
  },
};
</script>
<style lang="scss">
#gened-test-results-block {
  @mixin button-success {
    border-radius: 20px !important;
    padding: 6px 0;
    height: auto;
    min-height: 24px;
    line-height: 1;
    color: #fff;
    // background-color: #4bb543;
    // background-color: #4bb543;
    border: 0.6px solid #4bb543;
    color: #4bb543;

    min-width: 80px;
    font-weight: 500 !important;
    // border: none;
    text-align: center;
    font-size: 12px !important;
    letter-spacing: 0px !important;
    &:hover,
    &:active {
      // color: #fff;
      // background-color: #3fc380;
      border: 0.6px solid #4bb543;
      color: #4bb543;
    }
  }
  margin-top: 10px;
  .gened-test-card {
    background: #ffffff;
    border: 1.2px solid #e7e7f7;
    border-radius: 6.40567px;
    // column-one start
    .title {
      color: #273480;
      font-size: 18px;
      padding: 0.5rem 1rem;
    }
    .filters-results-inputs {
      padding: 1rem;
    }
    .calender-filters {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      .calender-filters-input {
        width: 48%;
        margin: 0.5rem 0;
        .el-input__inner,
        .el-input--prefix .el-input__inner {
          border: none;
          box-shadow: none;
          background: #ffffff;
          border: 0.922417px solid rgba(156, 156, 156, 0.5);
          border-radius: 5px;
          min-height: 30px;
          height: 35px;
        }
      }
    }
    .action-btn {
      text-align: right;
      padding: 20px 0 0;
      .add-btn {
        background-color: #273480;
        border: none;
        min-height: 30px;
        max-height: 35px;
        border-radius: 6.4px;
        color: #fff;
      }
    }
    // column-two end
  }
  .border-bottom {
    border-bottom: 1px solid #e7e7f7;
  }
  .primary-content-view-new {
    margin: 0;
    .listings__pagination {
      overflow: auto;
    }
    #accession-id {
      color: #eb5757;
      cursor: text;
    }
  }
  .selected-accession-id {
    .listings__table .el-table table tbody tr td .cell {
      font-weight: 500;
      font-size: 14px;
      color: #25213b;
    }

    .action-remove {
      color: #eb5757;
      border: none;
      background: transparent;
      padding: 0;
      min-height: 30px;
      &:hover {
        background-color: transparent;
      }
    }
  }
  .table-buttons {
    .button-added {
      @include button-success;
    }
    .button-add {
      @include button-success;

      // background-color: #5162fd;
      border: 0.6px solid #5162fd;
      color: #5162fd;
      &:hover,
      &:active {
        color: #fff;
        // background-color: #5162fd;
        border: 0.6px solid #5162fd;
        color: #5162fd;
      }
    }
  }
}
</style>
